import { usePunditUserContext } from "@/react/contexts/punditUserContext";

interface Member {
  admin: boolean;
  community_member_id: number;
}

export const useBlockDms = () => {
  const { currentCommunitySettings, currentCommunityMember } =
    usePunditUserContext();

  const isBlockDMsEnabled =
    currentCommunitySettings?.live_pulse_block_dms_enabled;

  const canBlockMemberDm = (member: Member) => {
    const isCurrentCommunityMember =
      currentCommunityMember?.id === member.community_member_id;
    return isBlockDMsEnabled && !(isCurrentCommunityMember || member.admin);
  };

  return { canBlockMemberDm };
};
